import axios, { getData } from "lib/axios"



export const getAllAdmins = async () => {
    return axios.get(`/admin-access`).then(getData)
}

export const getAdminById = async (id) => {
    return axios.get(`/admin-access/${id}`).then(getData)
}

export const postAdmin = async (data) => {
    return axios.post(`/admin-access`,data).then(getData)
}

export const getAllStaffNotAdmins = async () => {
    return axios.get(`/admin-access/staff`).then(getData)
}

export const getApproverGroup = async () => {
    return axios.get(`/approver-group`).then(getData)
}

export const getApproverGroupById = async (id) => {
    return axios.get(`/approver-group/${id}`).then(getData)
}

export const getApproverGroupStaff = async () => {
    return axios.get(`/approver-group/staff`).then(getData)
}

export const getApproverGroupStaffById = async (id) => {
    return axios.get(`/approver-group/staff/${id}`).then(getData)
}

export const postApproverGroupStaff = async (data) => {
    return axios.post("/approver-group", data).then(getData)
}

export const putApproverGroupStaff = async (id, data) => {
    return axios.put(`/approver-group/${id}`, data).then(getData)
}




